import React, { Component } from "react";
import PhoneInput from "react-phone-number-input";

class PhoneField extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      register,
      errors,
      label,
      name,
      rules,
      setValue,
      className,
      labelClassName,
      labelStyles,
      styles,
    } = this.props;

    const { onChange, onBlur } = register(name, rules);

    return (
      <>
        <div className={`flex flex-col items-start ${className}`}>
          <label
            className={`form-label font-bold float-start mb-1 ${labelClassName}`}
            style={labelStyles}
          >
            {rules?.required && <span className="text-red-500">*</span>} {label}
          </label>
          <span style={styles}>
            <PhoneInput
              placeholder="Enter phone number"
              onChange={(value) => {
                setValue(name, value || "", { shouldValidate: true, shouldDirty: true, shouldTouch: true });
              }}
              onBlur={onBlur}
              className="block w-full border h-fit border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 p-1"
            />
          </span>

          {errors[name] && (
            <span className="text-red-500 text-sm">{errors[name].message}</span>
          )}
        </div>
      </>
    );
  }
}

export default PhoneField;
